exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title-page{font-size:28px;font-size:1.75rem}@media (min-width:768px){.title-page{font-size:40px;font-size:2.5rem}}", ""]);

